import { api } from '@/api/client';
import type { Folder as FolderType, List as ListType, Section as SectionType, ListItem as ListItemType } from '@/types';

export const Folder = {
  list: (_orderBy?: string): Promise<FolderType[]> => api.folders.list(),
  get: (id: string): Promise<FolderType> => api.folders.get(id),
  create: (data: Partial<FolderType> & { name: string }): Promise<FolderType> => api.folders.create(data),
  update: (id: string, data: Partial<FolderType>): Promise<FolderType> => api.folders.update(id, data),
  delete: (id: string): Promise<void> => api.folders.delete(id),
};

export const List = {
  list: (_orderBy?: string): Promise<ListType[]> => api.lists.list(),
  get: (id: string): Promise<ListType> => api.lists.get(id),
  create: (data: Partial<ListType> & { title: string }): Promise<ListType> => api.lists.create(data),
  update: (id: string, data: Partial<ListType>): Promise<ListType> => api.lists.update(id, data),
  delete: (id: string): Promise<void> => api.lists.delete(id),
  setItemsCompleted: (id: string, completed: boolean): Promise<ListItemType[]> => api.lists.setItemsCompleted(id, completed),
  setInheritedItemCompleted: (id: string, itemId: string, completed: boolean) => api.lists.setInheritedItemCompleted(id, itemId, completed),
};

export const Section = {
  list: (_orderBy?: string): Promise<SectionType[]> => api.sections.list(),
  get: (id: string): Promise<SectionType> => api.sections.get(id),
  create: (data: Partial<SectionType> & { list_id: string }): Promise<SectionType> => api.sections.create(data),
  update: (id: string, data: Partial<SectionType>): Promise<SectionType> => api.sections.update(id, data),
  delete: (id: string): Promise<void> => api.sections.delete(id),
  setItemsCompleted: (id: string, completed: boolean): Promise<ListItemType[]> => api.sections.setItemsCompleted(id, completed),
};

export const ListItem = {
  list: (_orderBy?: string): Promise<ListItemType[]> => api.items.list(),
  get: (id: string): Promise<ListItemType> => api.items.get(id),
  create: (data: Partial<ListItemType> & { section_id: string; content: string }): Promise<ListItemType> => api.items.create(data),
  update: (id: string, data: Partial<ListItemType>): Promise<ListItemType> => api.items.update(id, data),
  delete: (id: string): Promise<void> => api.items.delete(id),
};

export { api };
export * from '@/types';
